import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState, useRef } from 'react';
import { Button, Form, Row, Col, Alert } from 'react-bootstrap'; // Adicionado Alert
import { Link, useNavigate } from 'react-router-dom';
import { PromotoraDTO } from '../../../shared/dto/promotoraDTO';
import { MatrizDTO } from '../../../shared/dto/matrizDTO';
import Spinner from '../../../shared/spinner';
import { ButtonAlterar, ButtonAtivar, ButtonEmpregador, ButtonFinanciamento, ButtonInativar, ButtonInfoGerais } from '../../../shared/buttons';
import PromotoraService from '../../../services/promotoraService';
import MatrizService from '../../../services/matrizService';
import ImportacaoService from '../../../services/importacaoService'; // <--- Importado
import ParametrosService from '../../../services/parametrosService';
import ConfirmModal from '../../../shared/customAlertConfirm';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import ResponsivePagination from 'react-responsive-pagination';
import { faFilter, faRefresh, faFileImport, faDownload, faTimes, faFile, faHistory } from '@fortawesome/free-solid-svg-icons'; // <--- Novos ícones
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Matriz } from '../../../shared/model/matriz';
import { cnpj } from 'cpf-cnpj-validator';
import { ProtectedActionInterno } from '../../../AccessControl';
import { useSlug } from '../../hooks/UseSlug';
import { ProtectedAction } from '../../../AccessControl';
import { Originador } from '../../../shared/model/originador';
import PromotoraDocumentacaoModal from './promotoraDocumentacaoModal';
import PromotoraJornadaModal from './promotoraJornadaModal';

const normalizarBooleano = (valor: any) => valor === true || valor === 1 || valor === '1' || valor === 'true';
const statusGestaoOptions = [
  { value: '', label: 'Todos' },
  { value: 'PENDENTE_DADOS_COMPLEMENTARES', label: 'Pendente dados complementares' },
  { value: 'PENDENTE_DOCUMENTACAO', label: 'Pendente documentação' },
  { value: 'DOCUMENTACAO_PARCIAL', label: 'Documentação parcial' },
  { value: 'PENDENTE_ANALISE', label: 'Pendente análise' },
  { value: 'ANALISE_JURIDICA', label: 'Análise jurídica' },
  { value: 'ENVIADO_ASSINATURA', label: 'Enviado para assinatura' },
  { value: 'PENDENTE_APROVACAO', label: 'Pendente aprovação' },
  { value: 'APROVADA', label: 'Aprovada' },
  { value: 'REPROVADA', label: 'Reprovada' },
  { value: 'MAIS_DOCUMENTACAO', label: 'Mais documentação' }
];

function PromotoraComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();

  // Services
  const promotoraService: PromotoraService = new PromotoraService();
  const matrizService = new MatrizService();
  const importacaoService = new ImportacaoService(); // <--- Instância
  const parametrosService = new ParametrosService();

  // States Principais
  const [loading, setLoading] = useState(true);
  const [promotora, setPromotora] = useState<PromotoraDTO[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [gestaoPromotora, setGestaoPromotora] = useState(false);
  const [documentacaoOpen, setDocumentacaoOpen] = useState(false);
  const [jornadaOpen, setJornadaOpen] = useState(false);
  const [promotoraSelecionada, setPromotoraSelecionada] = useState<PromotoraDTO | null>(null);
  const slug = useSlug(); // 2. Obtendo o slug  

  // Controle de Painéis
  const [filtros, setFiltros] = useState(false);
  const [importacaoOpen, setImportacaoOpen] = useState(false); // <--- State do Painel Importação

  // Filtros States
  const [matrizFiltro, setMatrizFiltro] = useState<string>('');
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [nomeFantasiaFiltro, setNomeFantasiaFiltro] = useState('');
  const [cnpjFiltro, setCnpjFiltro] = useState('');
  const [cidadeFiltro, setCidadeFiltro] = useState('');
  const [statusOrigemFiltro, setStatusOrigemFiltro] = useState('');
  const [statusGestaoFiltro, setStatusGestaoFiltro] = useState('');
  const [matrizes, setMatrizes] = useState<MatrizDTO[]>([]);

  // States de Importação
  const [fileToUpload, setFileToUpload] = useState<File | null>(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importMessage, setImportMessage] = useState<{ type: 'success' | 'danger', text: string } | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const pageSize = 10;

  // --- Toggle Painéis ---
  const toggleFiltros = () => {
    setFiltros(!filtros);
    setImportacaoOpen(false); // Fecha importação ao abrir filtros
  };

  const toggleImportacao = () => {
    setImportacaoOpen(!importacaoOpen);
    setFiltros(false); // Fecha filtros ao abrir importação
    setImportMessage(null);
  };

  const montarFiltros = () => {
    const filtrosData: any = {};
    if (matrizFiltro) filtrosData.matriz = matrizFiltro;
    if (codigoFiltro.trim()) filtrosData.codigo = codigoFiltro.trim();
    if (nomeFiltro.trim()) filtrosData.nome = nomeFiltro.trim();
    if (nomeFantasiaFiltro.trim()) filtrosData.nomeFantasia = nomeFantasiaFiltro.trim();
    if (cnpjFiltro.trim()) filtrosData.cnpj = cnpjFiltro.trim();
    if (cidadeFiltro.trim()) filtrosData.cidade = cidadeFiltro.trim();
    if (statusOrigemFiltro !== '') filtrosData.ativo = statusOrigemFiltro;
    if (gestaoPromotora && statusGestaoFiltro) filtrosData.statusGestao = statusGestaoFiltro;
    return filtrosData;
  };

  // --- Funções de Listagem ---
  const listAllPromotora = async (page = 1, filtrosOverride?: any) => {
    try {
      setLoading(true);

      const filtrosData: any = filtrosOverride ?? montarFiltros();

      const response = await promotoraService.listarTodasPromotoras(page - 1, pageSize, filtrosData);
      const data = response.data;

      setPromotora(data.content || data);
      setTotalPages(data.totalPages || 1);

      setCurrentPage(page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page: number) => {
    listAllPromotora(page);
  };

  const carregarParametros = async () => {
    try {
      const response = await parametrosService.listarTodosParametros();
      setGestaoPromotora(normalizarBooleano(response.data?.gestaoPromotora ?? response.data?.gestao_promotora));
    } catch (err) {
      console.error("Erro ao carregar parâmetros:", err);
      setGestaoPromotora(false);
    }
  };

  const abrirDocumentacao = (item: PromotoraDTO) => {
    setPromotoraSelecionada(item);
    setDocumentacaoOpen(true);
  };

  const abrirJornada = (item: PromotoraDTO) => {
    setPromotoraSelecionada(item);
    setJornadaOpen(true);
  };

  const formatarStatusGestao = (status?: string) => {
    const statusMap: Record<string, string> = {
      PENDENTE_DADOS_COMPLEMENTARES: 'Pendente dados complementares',
      PENDENTE_DOCUMENTACAO: 'Pendente documentação',
      DOCUMENTACAO_PARCIAL: 'Documentação parcial',
      PENDENTE_ANALISE: 'Pendente análise',
      ANALISE_JURIDICA: 'Análise jurídica',
      ENVIADO_ASSINATURA: 'Enviado para assinatura',
      PENDENTE_APROVACAO: 'Pendente aprovação',
      APROVADA: 'Aprovada',
      REPROVADA: 'Reprovada',
      MAIS_DOCUMENTACAO: 'Mais documentação'
    };

    return status ? statusMap[status] || status.replace(/_/g, ' ') : '-';
  };

  const getStatusGestaoClass = (status?: string) => {
    const statusClassMap: Record<string, string> = {
      PENDENTE_DADOS_COMPLEMENTARES: 'bg-secondary',
      PENDENTE_DOCUMENTACAO: 'bg-warning text-dark',
      DOCUMENTACAO_PARCIAL: 'bg-primary',
      PENDENTE_ANALISE: 'bg-info text-dark',
      ANALISE_JURIDICA: 'bg-dark',
      ENVIADO_ASSINATURA: 'bg-primary',
      PENDENTE_APROVACAO: 'bg-info text-dark',
      APROVADA: 'bg-success',
      REPROVADA: 'bg-danger',
      MAIS_DOCUMENTACAO: 'bg-primary'
    };

    return status ? statusClassMap[status] || 'bg-secondary' : 'bg-secondary';
  };

  const bloqueiaAtivacaoPorGestao = (item: PromotoraDTO) => {
    return gestaoPromotora && !!item.statusGestao && item.statusGestao !== 'APROVADA' && !item.ativo;
  };

  const ativarInativarPromotora = async (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id, ativo } = currentAction;
      try {
        await promotoraService.ativarInativarPromotora(id);
        listAllPromotora();
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  function formatarCNPJ(valor: string): string {
    valor = valor.replace(/\D/g, '');
    valor = valor.replace(/^(\d{2})(\d)/, '$1.$2');
    valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    valor = valor.replace(/\.(\d{3})(\d)/, '.$1/$2');
    valor = valor.replace(/(\d{4})(\d)/, '$1-$2');
    return valor.slice(0, 18);
  }

  // --- LÓGICA DE IMPORTAÇÃO ---
  const handleDownloadModelo = async () => {
    try {
      // Chama o endpoint passando 'PROMOTORA'
      const response = await importacaoService.baixarModelo('PROMOTORA');

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'modelo_importacao_promotora.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar modelo", error);
      setImportMessage({ type: 'danger', text: 'Erro ao baixar o modelo.' });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImportMessage(null);
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const extension = file.name.split('.').pop()?.toLowerCase();

      if (extension !== 'xlsx' && extension !== 'csv') {
        setImportMessage({ type: 'danger', text: 'Formato inválido. Apenas .xlsx e .csv são permitidos.' });
        setFileToUpload(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setFileToUpload(file);
    }
  };

  const handleImportar = async () => {
    if (!fileToUpload) {
      setImportMessage({ type: 'danger', text: 'Selecione um arquivo para importar.' });
      return;
    }

    try {
      setImportLoading(true);
      // Chama o endpoint de importação 'PROMOTORA'
      await importacaoService.importar('PROMOTORA', fileToUpload);

      setImportMessage({ type: 'success', text: 'Importação realizada com sucesso!' });
      setFileToUpload(null);
      if (fileInputRef.current) fileInputRef.current.value = "";

      // Recarrega lista
      listAllPromotora(1);

      // Fecha painel após sucesso
      setTimeout(() => {
        setImportacaoOpen(false);
        setImportMessage(null);
      }, 3000);

    } catch (error: any) {
      console.error("Erro na importação", error);
      const msg = error.response?.data || 'Erro ao processar importação.';
      setImportMessage({ type: 'danger', text: msg });
    } finally {
      setImportLoading(false);
    }
  };

  useEffect(() => {
    listAllPromotora(1);
    carregarParametros();

    const carregarMatrizes = async () => {
      try {
        const response = await matrizService.listarTodasMatrizesAtivas();
        setMatrizes(response.data || []);
      } catch (error) {
        console.error("Erro ao carregar matrizes:", error);
      }
    };

    carregarMatrizes();
  }, []);

  return (
    <>
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h5>Origens &gt; Promotora</h5>
          <div style={{ display: 'flex', gap: '10px' }}>
            {/* Botão Filtros */}
            <Button id="App-button-cor-principal-escura" onClick={toggleFiltros} active={filtros}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
              Filtros
            </Button>

            {/* Botão Importar */}
            <ProtectedActionInterno>
              <Button variant="outline-primary" onClick={toggleImportacao} active={importacaoOpen}>
                <FontAwesomeIcon icon={faFileImport} style={{ marginRight: '10px' }} />
                Importar
              </Button>
            </ProtectedActionInterno>

            {/* Botão Nova */}
            <ProtectedAction>
              <Button
                onClick={() => navigate(`${slug ? `/${slug}` : ''}/origens-promotora/inclusao`, { state: { id: null } })}
                id="App-button-cor-principal-escura"
              >
                + Nova Promotora
              </Button>
            </ProtectedAction>
          </div>
        </div>

        {/* --- ÁREA DE IMPORTAÇÃO --- */}
        {importacaoOpen && (
          <div className="card card-body mb-4" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
            <h6 className="card-title mb-3">
              <FontAwesomeIcon icon={faFileImport} className="me-2" />
              Importação em Lote
            </h6>
            <Row className="align-items-end g-3">
              <Col md={3}>
                <Form.Label>Passo 1: Modelo</Form.Label>
                <Button variant="outline-secondary" className="w-100" onClick={handleDownloadModelo}>
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Baixar Modelo
                </Button>
              </Col>

              <Col md={5}>
                <Form.Group controlId="formFile">
                  <Form.Label>Passo 2: Selecione o Arquivo (.xlsx)</Form.Label>
                  <Form.Control
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept=".xlsx, .csv"
                  />
                </Form.Group>
              </Col>

              <Col md={4} className="d-flex gap-2">
                <Button
                  id="App-button-cor-principal-escura"
                  className="flex-grow-1"
                  onClick={handleImportar}
                  disabled={!fileToUpload || importLoading}
                >
                  {importLoading ? <Spinner loading={true} /> : 'Confirmar Importação'}
                </Button>
                <Button variant="secondary" onClick={() => {
                  setImportacaoOpen(false);
                  setImportMessage(null);
                  setFileToUpload(null);
                }}>
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              </Col>
            </Row>

            {importMessage && (
              <Alert variant={importMessage.type} className="mt-3 mb-0">
                {importMessage.text}
              </Alert>
            )}
          </div>
        )}

        {/* --- ÁREA DE FILTROS --- */}
        {filtros ?
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='2' controlId="formSelectMatriz">
                <Form.Label>Matriz</Form.Label>
                <Form.Select value={matrizFiltro} onChange={(e) => setMatrizFiltro(e.target.value)}>
                  <option value="">Selecione</option>
                  {matrizes.map((matriz) => (
                    <option key={matriz.id} value={String(matriz.id)}>
                      {matriz.id} - {matriz.nome}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md='2' controlId="formBasicSelect">
                <Form.Label>Código </Form.Label>
                <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Nome</Form.Label>
                <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
              </Form.Group>

              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>CNPJ</Form.Label>
                <input
                  type="text"
                  className="form-control"
                  value={cnpjFiltro}
                  onChange={(e) => setCnpjFiltro(formatarCNPJ(e.target.value))}
                  maxLength={18}
                />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Cidade</Form.Label>
                <input type="text" className="form-control" value={cidadeFiltro} onChange={(e) => setCidadeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formSelectStatusOrigem">
                <Form.Label>Status Origem</Form.Label>
                <Form.Select
                  value={statusOrigemFiltro}
                  onChange={(e) => setStatusOrigemFiltro(e.target.value)}
                >
                  <option value="">Todas</option>
                  <option value="true">Ativas</option>
                  <option value="false">Inativas</option>
                </Form.Select>
              </Form.Group>
              {gestaoPromotora && (
                <Form.Group as={Col} md='4' controlId="formSelectStatusGestao">
                  <Form.Label>Status Gestão</Form.Label>
                  <Form.Select
                    value={statusGestaoFiltro}
                    onChange={(e) => setStatusGestaoFiltro(e.target.value)}
                  >
                    {statusGestaoOptions.map((item) => (
                      <option key={item.value || 'todos'} value={item.value}>{item.label}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
            </Row>
            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button type="button" id="App-button-cor-principal-escura" onClick={() => listAllPromotora(1, montarFiltros())}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                Aplicar
              </Button>
              <Button type="button" variant="secondary" onClick={() => {
                setMatrizFiltro(''); setCodigoFiltro(''); setNomeFiltro(''); setNomeFantasiaFiltro(''); setCnpjFiltro('');
                setCidadeFiltro(''); setStatusOrigemFiltro(''); setStatusGestaoFiltro('');
                listAllPromotora(1, {});
              }}>
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '5px' }} />
                Limpar
              </Button>
            </div>
          </>
          : null}

        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col" id="App-header-table">Promotora</th>
                    <th scope="col" id="App-header-table">CNPJ</th>
                    <th scope="col" id="App-header-table">Cidade</th>
                    <th scope="col" id="App-header-table">Telefone</th>
                    <th scope="col" id="App-header-table">Email</th>
                    <th scope="col" id="App-header-table">Matriz</th>
                    <th scope="col" id="App-header-table">{Originador.DESCRITIVO_GERAL}</th>
                    {gestaoPromotora && <th scope="col" id="App-header-table">Gestão</th>}
                    {gestaoPromotora && <th scope="col" id="App-header-table">Documentação Obrigatória</th>}
                    {gestaoPromotora && <th scope="col" id="App-header-table">Jornada</th>}
                    <ProtectedAction>
                      <th scope="col" id="App-header-table">Alteração</th>
                    </ProtectedAction>
                    <th scope="col" id="App-header-table">Empregadores</th>
                    <th scope="col" id="App-header-table">Financiamento</th>
                    <th scope="col" id="App-header-table">Inf. Gerais</th>
                    <ProtectedAction>
                      <th scope="col" id="App-header-table">Status</th>
                    </ProtectedAction>
                  </tr>
                </thead>
                <tbody>
                  {promotora.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id} - {item.nome}</td>
                      <td>{item.cnpj}</td>
                      <td>{item.cidade}</td>
                      <td>{item.telefoneComercial}</td>
                      <td>{item.email}</td>
                      <td>{item.matriz ? `${item.matriz} - ${item.nomeMatriz}` : '-'}</td>
                      <td>
                        {item.idOriginador ? `${item.idOriginador} - ${item.nomeOriginador || ''}` : '-'}
                      </td>
                      {gestaoPromotora && (
                        <td>
                          <span className={`badge ${getStatusGestaoClass(item.statusGestao)}`}>
                            {item.statusGestaoDescricao || formatarStatusGestao(item.statusGestao)}
                          </span>
                        </td>
                      )}
                      {gestaoPromotora && (
                        <td>
                          {item.statusGestao ? (
                            <Button size="sm" id="App-button-cor-principal" onClick={() => abrirDocumentacao(item)} title="Documentação">
                              <FontAwesomeIcon icon={faFile} className="me-1" />
                              {item.documentosAnexados ?? 0}/{item.documentosObrigatorios ?? 0}
                            </Button>
                          ) : '-'}
                        </td>
                      )}
                      {gestaoPromotora && (
                        <td>
                          {item.statusGestao ? (
                            <Button size="sm" id="App-button-cor-principal" onClick={() => abrirJornada(item)} title="Jornada">
                              <FontAwesomeIcon icon={faHistory} />
                            </Button>
                          ) : '-'}
                        </td>
                      )}
                      <ProtectedAction>
                        <td>
                          {/* 4. Link de alteração com Slug */}
                          <Link to={`${slug ? `/${slug}` : ''}/origens-promotora/alteracao`} state={{ id: item.id }}>
                            <ButtonAlterar />
                          </Link>
                        </td>
                      </ProtectedAction>
                      <td>
                        {/* 5. Link com Slug */}
                        <Link
                          to={`${slug ? `/${slug}` : ''}/promotora-empregador`}
                          state={{ chamada: 'promotora', idPromotora: item.id, idEmpregador: 0 }}
                        >
                          <ButtonEmpregador />
                        </Link>
                      </td>
                      <td>
                        {/* 5. Link com Slug */}
                          <Link
                              to={`${slug ? `/${slug}` : ''}/promotora-financiamento`}
                              state={{ 
                                chamada: 'promotora', 
                                idPromotora: item.id, 
                                idEmpregador: 0,
                                codigoFinanciamento: item.id, 
                                nomeFinanciamento: item.nome 
                              }}
                            >
                          <ButtonFinanciamento />
                        </Link>
                      </td>
                      <td>
                        {/* 6. Link com Slug */}
                        <Link
                          to={`${slug ? `/${slug}` : ''}/controle-rmc-informacoes-gerais`}
                          state={{ chamada: 'promotora', idPromotora: item.id, idEmpregador: 0 }}
                        >
                          <ButtonInfoGerais />
                        </Link>
                      </td>
                      <ProtectedAction>
                        <td>
                          {item.ativo ?
                            <ButtonInativar onClick={() => ativarInativarPromotora(item.id, item.ativo)} />
                            :
                            <ButtonAtivar
                              onClick={() => ativarInativarPromotora(item.id, item.ativo)}
                              disabled={bloqueiaAtivacaoPorGestao(item)}
                              title={bloqueiaAtivacaoPorGestao(item) ? 'Aguardando aprovação da gestão' : 'Ativar'}
                            />
                          }
                        </td>
                      </ProtectedAction>
                    </tr>
                  ))}
                </tbody>
              </table>

              <ResponsivePagination
                current={currentPage}
                total={totalPages}
                onPageChange={handlePageChange}
              />

              {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}

              <PromotoraDocumentacaoModal
                show={documentacaoOpen}
                promotora={promotoraSelecionada}
                onHide={() => setDocumentacaoOpen(false)}
                onUpdated={() => listAllPromotora(currentPage)}
              />

              <PromotoraJornadaModal
                show={jornadaOpen}
                promotora={promotoraSelecionada}
                onHide={() => setJornadaOpen(false)}
              />

            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default PromotoraComponent;
